export const includeLeftZero = number => {
  if (number > 999) {
    return number;
  }

  return ('000' + number).substr(-3);
};
